import { CatalogTrackResponseTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService';
import { TrackProgressResponseTypename } from '../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { ChapterAssetTypename, VideoAssetTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/TrackChirpService';
import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
export function trackToTrackCardModel(track, progress) {
  const {
    subCategories,
    hsSoftwareFilters,
    levelFilters,
    useCases,
    businessObjectives,
    language,
    visibleOnLoggedOutPage,
    deprecationFinalDate,
    deprecationWarningDate,
    deprecationCta,
    deprecationMessage,
    previewThumbnailSquareUrl,
    previewThumbnailRectangleUrl,
    pagePath,
    lessons,
    showDeprecationWarning,
    certification,
    active,
    contentResourceType,
    description,
    name,
    id,
    duration,
    displayOrder,
    visibility
  } = track;
  return {
    visibility: visibility || 'PUBLIC',
    displayOrder: displayOrder || undefined,
    contentResourceType: contentResourceType,
    productAccess: undefined,
    language: language.toUpperCase(),
    description,
    name,
    internalName: name,
    // Using name as internalName since it's not in TrackWithRelations
    previewThumbnailSquareUrl: previewThumbnailSquareUrl || undefined,
    previewThumbnailRectangleUrl: previewThumbnailRectangleUrl || undefined,
    deprecationWarningDate: deprecationWarningDate || undefined,
    deprecationFinalDate: deprecationFinalDate || undefined,
    deprecationCta: deprecationCta || undefined,
    deprecationMessage: deprecationMessage || undefined,
    previewThumbnailRectangle: {},
    previewThumbnailSquare: {},
    isDeprecated: Boolean(deprecationFinalDate && deprecationFinalDate < Date.now()),
    shouldShowDeprecationWarning: !!showDeprecationWarning,
    lessonIds: lessons.map(lesson => lesson.id),
    visibleOnLoggedOutPage: !!visibleOnLoggedOutPage,
    featuredHomePage: false,
    certification: !!certification,
    seoBadge: undefined,
    headline: undefined,
    canonicalUrl: undefined,
    titleTag: undefined,
    metaDescription: undefined,
    learnings: [],
    personas: [],
    seoTranscriptTitle: undefined,
    seoTranscript: undefined,
    partnerLogoImageUrl: undefined,
    partnerLogoImageAltText: undefined,
    seoRelatedTrackIds: [],
    seoRelatedLessonIds: [],
    seoRelatedContent: [],
    seoProfessorIds: [],
    seoThumbnailAltText: undefined,
    seoCustomTeaser: undefined,
    publishTime: undefined,
    duration,
    subCategories: subCategories,
    hsSoftwareFilters: hsSoftwareFilters || [],
    levelFilters: levelFilters || [],
    useCases: useCases || [],
    businessObjectives: businessObjectives || [],
    type: 'TRACK',
    active,
    id,
    pagePath: pagePath || undefined,
    __typename: CatalogTrackResponseTypename,
    progress
  };
}
function mapTrackContentProgressAwardToTrackAwardResponse(award, trackName, trackIdFallback) {
  const now = Date.now();
  const expiresAt = award.expiresAt;
  const isExpired = typeof expiresAt === 'number' ? expiresAt < now : false;
  return {
    certificate: award.certificate || undefined,
    expiresAt,
    isExpired,
    examAttemptId: award.examAttemptId || undefined,
    trackIdAward: award.trackIdAward || award.trackId || trackIdFallback || undefined,
    trackAwardLanguage: award.trackAwardLanguage,
    awardName: trackName || '',
    awardedAt: award.awardedAt,
    code: award.code,
    renewedAt: award.renewedAt,
    visibility: award.visibility ? readUnhandledEnumCase(award.visibility).toUpperCase() : undefined
  };
}
function mapChirpTrackAwardToProgressAward(award, trackName, trackLanguage) {
  return {
    certificate: award.certificate,
    expiresAt: award.expiresAt || 0,
    isExpired: award.expiresAt ? award.expiresAt < Date.now() : false,
    examAttemptId: award === null || award === void 0 ? void 0 : award.examAttemptId,
    trackIdAward: award === null || award === void 0 ? void 0 : award.trackIdAward,
    trackAwardLanguage: convertToSupportedLanguage(trackLanguage),
    awardName: trackName,
    awardedAt: award.awardedAt,
    code: award.code,
    renewedAt: award.renewedAt,
    visibility: award.visibility
  };
}
export function trackProgressToCardTrackProgress(trackProgress, track) {
  var _track$language;
  const completedLessons = track === null || track === void 0 ? void 0 : track.lessons.filter(l => {
    var _trackProgress$progre;
    return ((_trackProgress$progre = trackProgress.progress.find(p => p.lessonId === l.id)) === null || _trackProgress$progre === void 0 ? void 0 : _trackProgress$progre.status) === 'COMPLETED';
  });
  const completedProgress = trackProgress.progress.flatMap(p => p.contentProgress.filter(c => c.progressType === 'COMPLETED'));
  const completedContent = track === null || track === void 0 ? void 0 : track.lessons.flatMap(l => l.content.filter(c => completedProgress.find(p => p.contentId === c.id)));
  const completedContentDuration = (completedContent === null || completedContent === void 0 ? void 0 : completedContent.reduce((sum, content) => {
    var _content$readingTimeM;
    return sum + (content.duration || ((_content$readingTimeM = content.readingTimeMinutes) !== null && _content$readingTimeM !== void 0 ? _content$readingTimeM : 0) * 60);
  }, 0)) || 0;
  const mappedAward = track && trackProgress.trackAward ? mapTrackContentProgressAwardToTrackAwardResponse(trackProgress.trackAward, track.name, track.id) : undefined;
  return {
    id: (track === null || track === void 0 ? void 0 : track.id) || 0,
    context: 'INDIVIDUAL',
    language: track === null || track === void 0 || (_track$language = track.language) === null || _track$language === void 0 ? void 0 : _track$language.toUpperCase(),
    completedLessonIds: (completedLessons === null || completedLessons === void 0 ? void 0 : completedLessons.map(l => l.id)) || [],
    updatedAt: trackProgress.updatedAt || 0,
    type: 'TRACK',
    status: trackProgress.status === 'NOT_STARTED' ? 'NOT_STARTED' : trackProgress.status === 'COMPLETED' ? 'COMPLETED' : trackProgress.status === 'EXPIRING_SOON' ? 'EXPIRING_SOON' : 'IN_PROGRESS',
    hidden: false,
    completedPercentage: trackProgress.progressLevel || 0,
    remainingDuration: ((track === null || track === void 0 ? void 0 : track.duration) || 0) - completedContentDuration,
    award: mappedAward,
    __typename: 'com.hubspot.userprogress.bff.rpc.models.TrackProgressResponse',
    completedLessonCount: (completedLessons === null || completedLessons === void 0 ? void 0 : completedLessons.length) || 0
  };
}
export function chirpTrackProgressToCardTrackProgress(progress, track) {
  const completedLessons = track.lessons.filter(l => {
    var _progress$progress$fi;
    return ((_progress$progress$fi = progress.progress.find(p => p.lessonId === l.id)) === null || _progress$progress$fi === void 0 ? void 0 : _progress$progress$fi.status) === 'COMPLETED';
  });
  const completedContentProgress = progress.progress.flatMap(p => p.contentProgress.filter(c => c.progressType === 'COMPLETED'));
  const completedContentDuration = track.lessons.flatMap(l => l.content).filter(c => completedContentProgress.find(p => p.contentId === c.id)).reduce((sum, content) => {
    if (content.__typename === ChapterAssetTypename) {
      var _content$readingTimeM2;
      return sum + ((_content$readingTimeM2 = content.readingTimeMinutes) !== null && _content$readingTimeM2 !== void 0 ? _content$readingTimeM2 : 0) * 60;
    }
    if (content.__typename === VideoAssetTypename) {
      var _content$duration;
      return sum + ((_content$duration = content.duration) !== null && _content$duration !== void 0 ? _content$duration : 0);
    }
    return sum;
  }, 0);
  const mappedAwardFromProgress = progress.trackAward ? mapTrackContentProgressAwardToTrackAwardResponse(progress.trackAward, track.name, track.id) : undefined;
  const mappedAwardFromTrack = track !== null && track !== void 0 && track.award ? mapChirpTrackAwardToProgressAward(track.award, track.name, track.language) : undefined;
  const mappedAward = mappedAwardFromProgress || mappedAwardFromTrack;
  return {
    id: track.id,
    context: 'INDIVIDUAL',
    language: track.language.toUpperCase(),
    completedLessonIds: completedLessons.map(l => l.id),
    updatedAt: progress.updatedAt || 0,
    type: 'TRACK',
    status: progress.status === 'NOT_STARTED' ? 'NOT_STARTED' : progress.status === 'COMPLETED' ? 'COMPLETED' : progress.status === 'EXPIRING_SOON' ? 'EXPIRING_SOON' : 'IN_PROGRESS',
    hidden: false,
    completedPercentage: progress.progressLevel || 0,
    remainingDuration: track.duration - completedContentDuration,
    award: mappedAward,
    __typename: TrackProgressResponseTypename,
    completedLessonCount: completedLessons.length
  };
}
export function chirpTrackToTrackCardModelChirp(track, progress) {
  return {
    visibility: track.visibility,
    displayOrder: track.displayOrder,
    contentResourceType: 'TRACK',
    productAccess: track.productAccess,
    language: convertToSupportedLanguage(track.language),
    description: track.description,
    name: track.name,
    internalName: track.name,
    previewThumbnailSquareUrl: track.previewThumbnailSquareUrl,
    previewThumbnailRectangleUrl: track.previewThumbnailRectangleUrl,
    deprecationWarningDate: track.deprecationWarningDate,
    deprecationFinalDate: track.deprecationFinalDate,
    deprecationCta: track.deprecationCta,
    deprecationMessage: track.deprecationMessage,
    previewThumbnailRectangle: track.previewThumbnailRectangle,
    previewThumbnailSquare: track.previewThumbnailSquare,
    isDeprecated: Boolean(track.deprecationFinalDate && track.deprecationFinalDate < Date.now()),
    shouldShowDeprecationWarning: track.showDeprecationWarning,
    lessonIds: track.lessons.map(lesson => lesson.id),
    visibleOnLoggedOutPage: track.visibleOnLoggedOutPage,
    featuredHomePage: track.featuredHomePage,
    certification: track.certification,
    seoBadge: track.seoBadge,
    headline: track.headline,
    canonicalUrl: track.canonicalUrl,
    titleTag: track.titleTag,
    metaDescription: track.metaDescription,
    learnings: track.learnings,
    personas: track.personas,
    seoTranscriptTitle: track.seoTranscriptTitle,
    seoTranscript: track.seoTranscript,
    partnerLogoImageUrl: track.partnerLogoImageUrl,
    partnerLogoImageAltText: track.partnerLogoImageAltText,
    seoRelatedTrackIds: track.seoRelatedTrackIds,
    seoRelatedLessonIds: track.seoRelatedLessonIds,
    seoRelatedContent: track.seoRelatedContent,
    seoProfessorIds: track.seoProfessorIds,
    seoThumbnailAltText: track.seoThumbnailAltText,
    seoCustomTeaser: track.seoCustomTeaser,
    publishTime: undefined,
    duration: track.duration,
    subCategories: track.subCategories,
    hsSoftwareFilters: track.hsSoftwareFilters,
    levelFilters: track.levelFilters,
    useCases: track.useCases,
    businessObjectives: track.businessObjectives,
    type: 'TRACK',
    active: track.active,
    id: track.id,
    pagePath: track.pagePath,
    __typename: CatalogTrackResponseTypename,
    progress
  };
}
export const maybeTrackCardModelWithProgress = (track, progress) => track && trackToTrackCardModel(track, progress && trackProgressToCardTrackProgress(progress, track));
export const maybeChirpTrackCardModelWithProgress = (track, progress) => {
  if (!track) {
    return undefined;
  }
  const maybeProgress = progress && chirpTrackProgressToCardTrackProgress(progress, track);
  return chirpTrackToTrackCardModelChirp(track, maybeProgress);
};
export const isVideoAsset = asset => {
  return asset.contentType === 'VIDEO';
};
export const isPracticalExerciseAsset = asset => {
  return asset.contentType === 'PRACTICAL_EXERCISE_FLOW';
};
export const isQuizAsset = asset => {
  return asset.contentType === 'QUIZ';
};